export const MINAR_SIDUR_URL = 'https://login.signet.is/login?id=minarsidur.briet.is';
export const APPLY_FOR_APARTMENT_URL = '/umsokn/';
export const BASE_API_URL = '/api';
export const LOGIN_URL = 'https://login.signet.is/login?id=umsokn.briet.is';
